var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3645",
    "data-name": "Group 3645",
    transform: "translate(-699 -2944)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(699 2944)",
    fill: "rgba(38,159,112,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "permissions-svgrepo-com",
    d: "M22.083,14.722a2.947,2.947,0,0,1,2.944,2.944v1.472H26.5v5.153A2.211,2.211,0,0,1,24.291,26.5H19.874a2.211,2.211,0,0,1-2.208-2.208V19.138h1.472V17.666a2.947,2.947,0,0,1,2.944-2.944ZM11.041,0A6.575,6.575,0,0,1,14.56,1.016a6.226,6.226,0,0,1,1.163.913,6.453,6.453,0,0,1,1.491,2.344,6.59,6.59,0,0,1,.356,1.3l.031.2.05.278-.007,0v0l-.727.448a4.374,4.374,0,0,1-2.665.854h-.016a4.973,4.973,0,0,1-.9-.078l-.024-.006a4.611,4.611,0,0,1-1.743-.768c-.132-.087-.259-.168-.389-.243a2.747,2.747,0,0,0-1.493-.377h0a2.811,2.811,0,0,0-1.675.5c-.062.04-.122.075-.185.116-.043.028-.093.057-.137.085-.087.056-.175.112-.271.168-.062.037-.131.069-.2.1-.1.05-.193.1-.3.144-.091.041-.19.077-.291.112s-.2.059-.306.087a3.9,3.9,0,0,1-.384.085l-.046.01V8.1a3.56,3.56,0,0,0,.059.692,5.139,5.139,0,0,0,10.217-.265,5.9,5.9,0,0,0,1.5-.751V8.1a6.621,6.621,0,0,1-2.931,5.494H14.8a22.651,22.651,0,0,1,4.059,1.073,4.385,4.385,0,0,0-1.2,3H16.194v6.625c0,.019.006.037.006.057a20.47,20.47,0,0,1-5.158.679A20.29,20.29,0,0,1,.347,21.972L0,21.756v-2.71a4.6,4.6,0,0,1,3.018-4.324A22.258,22.258,0,0,1,7.3,13.585h.066a6.623,6.623,0,0,1-2.9-4.752A5.993,5.993,0,0,1,4.417,8.1V6.625A6.446,6.446,0,0,1,4.8,4.417,6.632,6.632,0,0,1,11.041,0ZM22.083,16.194a1.475,1.475,0,0,0-1.472,1.472v1.472h2.944V17.666a1.475,1.475,0,0,0-1.472-1.472Z",
    transform: "translate(710 2955)",
    fill: "#28946a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanResource);
export default __webpack_public_path__ + "static/media/humanResource.fb26788ae8e511a8bc23a2571dd55d3f.svg";
export { ForwardRef as ReactComponent };